import AppLoading, {AppLoadError} from '../../app_loading';
import React from "react";
import { fetchSettings, updateSettings} from "../../../util/settings_api_util"
import { fetchFirstAvailableRotation } from "../../../util/first_available_api_util"
import Select from "react-select"

export default class AdminSettings extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      initialLoading:true, loadError:false,
      newOrderProcess: false,
      bundleDiscountWith2: 0,
      bundleDiscountWith3: 0,
      bundleDiscountWith4: 0,
      cubicasaVisible: false,
      cubicasaEnabled: false,
      cubicasaAvailable: false,
      cubicasaSaving: false,
      ownerView: false,
      firstAvailable: false,
      firstAvailableSaving: false,
      rotation: [],
      rotationPick: null
    }
    this.handleToggle = this.handleToggle.bind(this);
    this.handleNumberInput = this.handleNumberInput.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() { this.loadInitial() }
  loadInitial = () => {
    this.setState({initialLoading:true,loadError:false})
    fetchSettings().then(data => {
      this.setState({
        initialLoading:false,
        newOrderProcess: data.new_order_process,
        bundleDiscountWith2: data.bundle_discount_with_2,
        bundleDiscountWith3: data.bundle_discount_with_3,
        bundleDiscountWith4: data.bundle_discount_with_4,
        cubicasaVisible: Object.prototype.hasOwnProperty.call(data, 'cubicasa_delivery_enabled'),
        cubicasaEnabled: data.cubicasa_delivery_enabled,
        cubicasaAvailable: data.cubicasa_delivery_available,
        // Owner-only keys (CubiCasa) mark the owner's view; the /book switch is owner-only too.
        ownerView: Object.prototype.hasOwnProperty.call(data, 'cubicasa_delivery_enabled'),
        firstAvailable: !!data.book_first_available
      });
      if (Object.prototype.hasOwnProperty.call(data, 'cubicasa_delivery_enabled')) this.loadRotation();
    }).catch(() => this.setState({initialLoading:false,loadError:true}));
  }

  handleToggle() {
    this.setState(prevState => ({ newOrderProcess: !prevState.newOrderProcess }))
  }

  handleCubicasaToggle = () => {
    if (this.state.cubicasaSaving || !this.state.cubicasaAvailable) return;
    const enabled = !this.state.cubicasaEnabled;
    this.setState({ cubicasaSaving: true });
    updateSettings({ cubicasa_delivery_enabled: enabled })
      .then(() => {
        this.setState({ cubicasaEnabled: enabled, cubicasaSaving: false });
        this.props.showToast(`CubiCasa automatic imports ${enabled ? 'enabled' : 'paused'}.`);
      })
      .catch((error) => {
        this.setState({ cubicasaSaving: false });
        this.props.showToast(error.responseJSON?.error || 'Unable to change CubiCasa imports. Please try again.');
      });
  }

  loadRotation = () => {
    fetchFirstAvailableRotation().then(data => this.setState({ rotation: data.photographers || [] })).catch(() => {});
  }

  handleFirstAvailableToggle = () => {
    if (this.state.firstAvailableSaving) return;
    const enabled = !this.state.firstAvailable;
    this.setState({ firstAvailableSaving: true });
    updateSettings({ book_first_available: enabled })
      .then(() => {
        this.setState({ firstAvailable: enabled, firstAvailableSaving: false });
        this.props.showToast(`First-available booking on /book ${enabled ? 'turned on' : 'turned off'}.`);
      })
      .catch(() => {
        this.setState({ firstAvailableSaving: false });
        this.props.showToast('Unable to change the /book setting. Please try again.');
      });
  }

  copyBookingLink = (photographer) => {
    const link = `https://www.modernangles.com/book?photographer=${photographer.id}`;
    const done = () => this.props.showToast(`Booking link for ${photographer.name} copied.`);
    try {
      navigator.clipboard.writeText(link).then(done).catch(() => window.prompt('Copy this booking link:', link));
    } catch (e) {
      window.prompt('Copy this booking link:', link);
    }
  }

  handleNumberInput(field) {
    return (e) => {
      const value = parseFloat(e.target.value);
      this.setState({ [field]: isNaN(value) ? null : value });
    }

  }

  handleSubmit = () => {
    const { newOrderProcess, bundleDiscountWith2, bundleDiscountWith3, bundleDiscountWith4 } = this.state;

    const requestBody = {
      new_order_process: newOrderProcess,
      bundle_discount_with_2: bundleDiscountWith2,
      bundle_discount_with_3: bundleDiscountWith3,
      bundle_discount_with_4: bundleDiscountWith4
    };

    updateSettings(requestBody)
      .then(() => this.props.showToast("Settings updated successfully"))
      .catch(() => this.props.showToast("Error updating settings."));
  }

  render() {
    if (this.state.initialLoading) return <AppLoading label="Loading admin settings…"/>
    if (this.state.loadError) return <AppLoadError retry={this.loadInitial}/>
    return (
      <div className="settingsPreferencesGroupingDiv">
        <div className="settingsPreferences">
          <div className="settingsComponentHeading">Admin Settings</div>
          <div className="settingsGroup">
            {this.state.cubicasaVisible && <div className="settingsCompanyInput">
              <span className="formLabel">Automatic CubiCasa Floor Plans</span>
              <button type="button" role="switch" aria-label="Automatic CubiCasa floor-plan imports"
                aria-checked={!!this.state.cubicasaEnabled}
                disabled={this.state.cubicasaSaving || !this.state.cubicasaAvailable}
                className={`toggle-switch ${this.state.cubicasaEnabled ? 'active' : ''}`}
                style={{ border: 0, padding: 0, flexShrink: 0 }}
                onClick={this.handleCubicasaToggle}>
                <span className="toggle-knob" style={{ left: 0, top: 0 }}></span>
              </button>
              <p style={{ margin: '10px 0 0', fontSize: '14px', lineHeight: 1.5 }}>
                {this.state.cubicasaSaving ? 'Saving…' : this.state.cubicasaEnabled ? 'On' : 'Off'}
                {' — '}{this.state.cubicasaAvailable
                  ? 'Import completed JPEGs and PDFs with dimensions. CubiCasa edits replace earlier automatic imports. Manual uploads stay available.'
                  : 'CubiCasa connection setup is required before enabling imports.'}
              </p>
            </div>}
            {this.state.ownerView && <div className="settingsCompanyInput">
              <span className="formLabel">First-available booking on /book</span>
              <button type="button" role="switch" aria-label="First-available booking on /book"
                aria-checked={!!this.state.firstAvailable}
                disabled={this.state.firstAvailableSaving}
                className={`toggle-switch ${this.state.firstAvailable ? 'active' : ''}`}
                style={{ border: 0, padding: 0, flexShrink: 0 }}
                onClick={this.handleFirstAvailableToggle}>
                <span className="toggle-knob" style={{ left: 0, top: 0 }}></span>
              </button>
              <p style={{ margin: '10px 0 0', fontSize: '14px', lineHeight: 1.5 }}>
                {this.state.firstAvailableSaving ? 'Saving…' : this.state.firstAvailable ? 'On' : 'Off'}
                {' — '}New visitors on /book pick a date and time; a photographer is assigned by rotation. Everyone else books as usual.
              </p>
              {this.state.rotation.length > 0 && (() => {
                const totalMonth = this.state.rotation.reduce((n, p) => n + p.this_month, 0)
                const options = this.state.rotation.map(p => ({ value: p.id, label: `${p.name} (${p.this_month} this month)` }))
                const picked = this.state.rotation.find(p => p.id === this.state.rotationPick)
                return <div style={{ marginTop: 14, maxWidth: 520 }}>
                  <div style={{ fontSize: 14, color: '#525a6c', marginBottom: 8 }}>{totalMonth} auto-assigned job{totalMonth === 1 ? '' : 's'} this month. Pick a photographer to see their count or copy their booking link.</div>
                  <Select
                    options={options}
                    value={options.find(o => o.value === this.state.rotationPick) || null}
                    onChange={o => this.setState({ rotationPick: o ? o.value : null })}
                    placeholder="Search photographers…"
                    isClearable
                    isSearchable
                    aria-label="Photographer"
                    menuPlacement="auto"
                  />
                  {picked && <div style={{ marginTop: 12, display: 'flex', flexWrap: 'wrap', gap: 16, alignItems: 'center', fontSize: 14 }}>
                    <span><b>{picked.this_month}</b> this month</span>
                    <span><b>{picked.all_time}</b> all time</span>
                    <span>Last: {picked.last_assigned_at ? new Date(picked.last_assigned_at).toLocaleString('en-US', { timeZone: 'America/New_York', month: 'short', day: 'numeric', year: 'numeric', hour: 'numeric', minute: '2-digit' }) + ' ET' : 'never'}</span>
                    <button type="button" onClick={() => this.copyBookingLink(picked)} style={{ border: '1px solid #3357ff', borderRadius: 8, background: '#ffffff', color: '#3357ff', fontWeight: 700, cursor: 'pointer', minHeight: 40, padding: '0 14px' }}>Copy booking link</button>
                  </div>}
                </div>
              })()}
            </div>}
            <div className="settingsCompanyInput">
              <span className="formLabel">New Order Process</span>
              <div
                className={`toggle-switch ${this.state.newOrderProcess ? 'active' : ''}`}
                onClick={() => this.setState({ newOrderProcess: !this.state.newOrderProcess })}
              >
                <div className="toggle-knob"></div>
              </div>
            </div>

            <div className="settingsCompanyInput">
              <label id="formLabel">Bundle Discount for 2 Services (%)</label>
              <input className="formInput" type="number" step="any" value={this.state.bundleDiscountWith2} onChange={this.handleNumberInput("bundleDiscountWith2")} />
            </div>

            <div className="settingsCompanyInput">
              <label id="formLabel">Bundle Discount for 3 Services (%)</label>
              <input className="formInput" type="number" step="any" value={this.state.bundleDiscountWith3} onChange={this.handleNumberInput("bundleDiscountWith3")} />
            </div>

            <div className="settingsCompanyInput">
              <label id="formLabel">Bundle Discount for 4+ Services (%)</label>
              <input className="formInput" type="number" step="any" value={this.state.bundleDiscountWith4} onChange={this.handleNumberInput("bundleDiscountWith4")} />
            </div>

            <button className="settingsButton companyButton" onClick={() => this.handleSubmit()}>Update Settings</button>
          </div>
        </div>
      </div>
    );}
}
